import React from "react";
import { Route } from "react-router-dom";

/**
 * Reusable Route component that passes signIn handler to the component
 */
const RouteWithSignIn = ({ component: Component, signInHandler, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => <Component {...props} signIn={signInHandler} />}
    />
  );
};

export default RouteWithSignIn;
